<template>
  <yektanet-signup v-if="isYektanetPlt" />
  <lead-signup v-else-if="isLeadPlt" />
  <old-signup v-else />
</template>

<script>
import OldSignup from "./OldSignup.vue";
import YektanetSignup from "./YektanetSignup.vue";
import LeadSignup from "./LeadSignup.vue";

import { getParam } from "~/utils";

export default {
  components: {
    OldSignup,
    YektanetSignup,
    LeadSignup,
  },
  data: () => ({
    isYektanetPlt: false,
    isLeadPlt: serverData.isLeadPanelSignup,
  }),

  mounted() {
    this.isYektanetPlt = ![
      "triboon",
      "najva",
      "jaryan",
      "sanjab",
      "adivery",
      "novinhub",
      "chavosh",
      "lead",
      "pajva",
      "fahva",
      "bordboard",
    ].includes(getParam("plt"));
  },
};
</script>
